import React from 'react';
import styled from "styled-components";

type BannerProps = {
    mainText: string;
    bodyText?: string;
}

const Container = styled.div`
    padding: 1em;
    width: 100%;
    display:flex;
    align-items:center;
    background: var(--main-theme-gradient);
`;

const BannerBody = styled.div`
    margin-left: 20%;
`;

const MainText = styled.p`
    font-family: Lato-Bold;
    font-size: 3rem;
    color: #FFF;
`;

const BodyText = styled.p`
    font-family: Lato-Regular;
    font-size: 1.4rem;
    color: #FFF;
`;
function Banner({ mainText, bodyText }: BannerProps) {

    return (
        <Container>
            <BannerBody>
                <MainText>{mainText}</MainText>
                {bodyText &&
                    <BodyText>{bodyText}</BodyText>
                }
            </BannerBody>
        </Container>
    );
}
export default Banner;
